import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { FaStar } from 'react-icons/fa6';
import 'swiper/css';
import 'swiper/css/pagination';



function ReviewCard({ title, subtitle, stars, text }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="h-full text-center flex flex-col justify-center border border-black/10 rounded-lg shadow-md p-6 bg-black/80 text-white">
      <p className="font-semibold text-xl text-white">{title}</p>
      {subtitle && <p className="font-bold italic">{subtitle}</p>}
      <div className="flex gap-1 my-3 justify-center">
        {Array.from({ length: stars }).map((_, i) => (
          <FaStar key={i} className="w-5 h-5 text-mcare-green" />
        ))}
      </div>

      <p className={`text-white ${expanded ? '' : 'truncate'}`}>
        {text}
      </p>

      <button
        type="button"
        onClick={() => setExpanded((prev) => !prev)}
        className="mt-2 text-sm text-mcare-green underline self-center hover:text-white">
        {expanded ? 'Mostra di meno' : 'Mostra di più'}
      </button>
    </div>
  );
}

function Reviews({reviews}) {
  return (
    <div className="w-full z-10">
      <h2 className="text-3xl font-semibold text-center mb-20 mx-5 sm:mx-0 text-white panoragraf-light" data-aos="fade">
        Un metodo validato da chi è tornato più forte di prima
      </h2>

      <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        spaceBetween={24}
        grabCursor={true}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 6000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          768: { slidesPerView: 2 },
          1280: { slidesPerView: 3 },
        }}
        className="lg:w-[80%] w-[90%] mx-auto pb-12"
        data-aos="fade"
        data-aos-delay="200">
        {reviews.map((review, index) => (
          <SwiperSlide key={index} className="h-auto py-1 ">
            <ReviewCard {...review}  />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Reviews;
